export default "__VITE_ASSET__DhEigzse__"